import { fetcher } from "helpers/fetcher";

import {
  TDeleteJobListingFacilitiesReq,
  TDeleteJobListingFacilitiesRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const deleteJobListingFacilities = async (
  payload: TDeleteJobListingFacilitiesReq
) => {
  return await fetcher<
    TDeleteJobListingFacilitiesRes,
    TDeleteJobListingFacilitiesReq["data"]
  >(ENDPOINT.CORPORATION.DELETE_JOB_LISTING_FACILITY, {
    data: payload.data,
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.CORPORATION.DELETE_JOB_LISTING_FACILITY.version,
      [API_HEADER.CORP_ID]: payload.idCorp,
    },
  });
};

export const mutationDeleteJobListingFacilities = async (
  payload: TDeleteJobListingFacilitiesReq
) => {
  return (await deleteJobListingFacilities(payload)).data;
};

mutationDeleteJobListingFacilities._key = (
  payload: TDeleteJobListingFacilitiesReq
) => [ENDPOINT.CORPORATION.DELETE_JOB_LISTING_FACILITY.url, payload];
